import React, { memo, useEffect, useState } from 'react';
import styles from './styles.module.css';
import { Table, Loading } from '../../../../../common/ui';
import { getCustomers } from '../../actions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const CustomerTable = memo(
  ({
    getCustomers,
    customersState: { customersData, pagination, isLoading },
    searchKeyword = '',
  }) => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
      getCustomers({ page, limit });
    }, []);

    useEffect(() => {
      getCustomers({ page, limit, searchKeyword });
    }, [searchKeyword, page, limit, getCustomers]);

    const handleChangePage = (event, newPage) => {
      setPage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
      const value = event?.target?.value != null ? +event.target.value : 10;
      setLimit(value);
      setPage(1);
    };

    const columns = [
      { id: 'name', label: 'Name', minWidth: 150 },
      { id: 'phone', label: 'Phone', minWidth: 100 },
      { id: 'email', label: 'Email', minWidth: 150 },
      { id: 'nic', label: 'NIC', minWidth: 100 },
      { id: 'address', label: 'Address', minWidth: 200 },
      { id: 'age', label: 'Age', minWidth: 50 },
      { id: 'gender', label: 'Gender', minWidth: 50 },
    ];

    const totalCount = pagination?.totalRecords ?? 0;

    if (isLoading) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.loadingWrap}>
            <Loading variant="inline" label="" />
          </div>
        </div>
      );
    }

    return (
      <div className={styles.wrapper}>
        <Table
          columns={columns}
          rows={customersData || []}
          page={page - 1}
          rowsPerPage={limit}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalCount={totalCount}
          disableInternalPagination
        />
      </div>
    );
  }
);

CustomerTable.propTypes = {
  getCustomers: PropTypes.func.isRequired,
  customersState: PropTypes.shape({
    customersData: PropTypes.array,
    pagination: PropTypes.object,
    isLoading: PropTypes.bool,
  }).isRequired,
  searchKeyword: PropTypes.string,
};

const mapStateToProps = (state) => ({
  customersState: state.customersState,
});

export default connect(mapStateToProps, { getCustomers })(CustomerTable);
